import { render, staticRenderFns } from "./ClientHistorical.vue?vue&type=template&id=38f77056&scoped=true"
import script from "./ClientHistorical.vue?vue&type=script&lang=js"
export * from "./ClientHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f77056",
  null
  
)

export default component.exports